import React from 'react';
import AddUserForm from '../../../app/administration/users/components/AddUser';

import EditUserForm from '../../../app/administration/users/components/EditUser';

import ShowUserForm from '../../../app/administration/users/components/ShowUser';
import AddDepartment from '../../../app/administration/department/components/AddDepartment';
import EditDepartment from '../../../app/administration/department/components/EditDepartment';
import PreviewDepartment from '../../../app/administration/department/components/PreviewDepartment';
import DeleteDepartment from '../../../app/administration/department/components/DeleteDepartment';
import AddExternalization from '../../../app/externalization/sectorForms/components/externalizationForm/AddExternalization';
import EditExternalization from '../../../app/externalization/sectorForms/components/externalizationForm/EditExternalization';
import AddExternalizationTemplates
  from '../../../app/administration/externalizationsTemplates/components/AddExternalizationTemplates';
import EditExternalizationTemplates
  from '../../../app/administration/externalizationsTemplates/components/EditExternalizationTemplates';
import PreviewExternalizationTemplates
  from '../../../app/administration/externalizationsTemplates/components/PreviewExternalizationTemplates';
import DeleteExternalizationTemplates
  from '../../../app/administration/externalizationsTemplates/components/DeleteExternalizationTemplates';
import AddServiceProvider from '../../../app/administration/serviceProviders/components/AddServiceProvider';
import EditServiceProvider from '../../../app/administration/serviceProviders/components/EditServiceProvider';
import PreviewServiceProvider from '../../../app/administration/serviceProviders/components/PreviewServiceProvider';
import DeleteServiceProvider from '../../../app/administration/serviceProviders/components/DeleteServiceProvider';


const modalBody = (caseType) => {
  switch (caseType) {
  
    case 'user':
      return {
        add: AddUserForm,
        edit: EditUserForm,
        show: ShowUserForm,
        delete: null,
      };
      case 'departments':
      return {
        add: AddDepartment,
        edit: EditDepartment,
        show: PreviewDepartment,
        delete: DeleteDepartment,
      };
      case 'externalization':
      return {
        add: AddExternalization,
        edit: EditExternalization,
      };
    case 'externalizationsTemplates':
      return {
        add: AddExternalizationTemplates,
        edit: EditExternalizationTemplates,
        show: PreviewExternalizationTemplates,
        delete: DeleteExternalizationTemplates,
      };
    case 'serviceProviders':
      return {
        add: AddServiceProvider,
        edit: EditServiceProvider,
        show: PreviewServiceProvider,
        delete: DeleteServiceProvider,
      };
    default:
      return {
        add: null,
        edit: null,
        show: null,
        delete: null,
      };
  }
};

export default modalBody;
